import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { AuthService } from 'src/app/core/service/auth.service';
import { BehaviorSubject } from 'rxjs';
import { User } from 'src/app/core/models/user';

declare const Waves: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  level1Menu = '';
  level2Menu = '';
  level3Menu = '';
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  headerHeight = 60;
  routerObj = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    public authService: AuthService,
    private router: Router
  ) {

    this.authService.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('user'))
    );
    this.authService.user = JSON.parse(localStorage.getItem('user'));
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects.split('?')[0];

        this.setActiveMenuByUrl(currentUrl);

        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
  }

  setActiveMenuByUrl(currentUrl: string) {
    this.level1Menu = '';
    this.level2Menu = '';
    this.level3Menu = '';

    if (!this.sidebarItems || this.sidebarItems.length === 0) {
      return;
    }

    for (const item of this.sidebarItems) {
      if (item.path === currentUrl) {
        this.level1Menu = item.moduleName;
        return;
      }

      if (item.submenu?.length) {
        for (const sub of item.submenu) {
          if (sub.path === currentUrl) {
            this.level1Menu = item.moduleName;
            this.level2Menu = sub.moduleName;
            return;
          }

          if (sub.submenu?.length) {
            for (const subSub of sub.submenu) {
              if (subSub.path === currentUrl) {
                this.level1Menu = item.moduleName;
                this.level2Menu = sub.moduleName;
                this.level3Menu = subSub.moduleName;
                return;
              }
            }
          }
        }
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  
  callLevel1Toggle(event: any, element: any) {
    event.preventDefault();

    this.level1Menu = element === this.level1Menu ? '' : element;
  }

  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = '0';
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = '0';
    } else {
      this.level3Menu = element;
    }
  }

  ngOnInit() {
    if (this.authService.currentUserValue) {
      this.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems')) || [];
    }

    this.initLeftSidebar();
    this.bodyTag = this.document.body;

    this.setActiveMenuByUrl(this.router.url.split('?')[0]);
  }


  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest('body');
    const bigLogo = this.document.getElementById('big-Logo')
    const smallLogo = this.document.getElementById('small-Logo')

    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');


      this.renderer.removeClass(bigLogo, 'hide-logo');
      this.renderer.removeClass(smallLogo, 'show-logo');
      this.renderer.addClass(bigLogo, 'show-logo');
      this.renderer.addClass(smallLogo, 'hide-logo');
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest('body');
    const bigLogo = this.document.getElementById('big-Logo')
    const smallLogo = this.document.getElementById('small-Logo')

    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');

      this.renderer.removeClass(bigLogo, 'show-logo');
      this.renderer.removeClass(smallLogo, 'hide-logo');
      this.renderer.addClass(bigLogo, 'hide-logo');
      this.renderer.addClass(smallLogo, 'show-logo');
    }
  }

}

